/* eslint-disable import/no-anonymous-default-export */
export default {
    title: 'light',

    colors: {
        primary: '#D9CAB3',
        secundary: '#fff',

        background: '#f5f5f5',
        text: '#333',
        details: "#c0b29e"
    },
}